import KDriverBreakToggle from "./KDriverBreakToggle";
import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KDriversTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no drivers to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching drivers found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "user.name"
		}
	},

	data: () => ( {
		crud: "yard_drivers"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "user.name"
				},
				{
					text: "CDL",
					value: "cdl"
				},
				{
					text: "Temporary Driver",
					value: "temporary"
				},
				{
					text: "Break",
					value: "onBreak"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteDriver( driver ) {
			const deleteIndex = this.items.findIndex( item => driver.id === item.id );

			return driver.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		},

		genBreakContent( driver ) {
			if ( this.canEdit ) {
				return <KDriverBreakToggle
					class="my-1"
					onInput={onBreak => {
						driver.onBreak = onBreak;
						driver.save();
					}}
					value={driver.onBreak}
				></KDriverBreakToggle>;
			}

			return driver.onBreak ? "On Break" : "Available";
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.cdl": ( { item } ) => (
					item.cdl
						? <VIcon class="success--text">done</VIcon>
						: <VIcon class="error--text">clear</VIcon>
				),

				"item.temporary": ( { item } ) => (
					item.temporary
						? <VIcon class="success--text">done</VIcon>
						: <VIcon class="error--text">clear</VIcon>
				),

				"item.onBreak": ( { item } ) => this.genBreakContent( item ),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "yardDriver",
								params: { idDriver: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete driver" )}
								onConfirm={() => this.deleteDriver( item )}
								title="Delete Driver"
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
							>Are you sure you want to delete the driver <strong>{item.user.name}</strong>?</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
